(() => {
  if (window.acustomFabricPdpLoaded) return;
  window.acustomFabricPdpLoaded = true;
  function sync(product) {
    const selected = product.querySelector('select[name="id"]');
    const id = selected?.value || '';
    product.querySelectorAll('[data-acustom-fabric-variant]').forEach(row => {
      row.hidden = row.dataset.acustomFabricVariant !== id;
    });
    const data = product.querySelector('[data-acustom-delivery-data]');
    const message = product.querySelector('[data-acustom-delivery]');
    if (data && message) {
      const estimate = JSON.parse(data.textContent)[id];
      message.hidden = !estimate;
      message.querySelector('[data-acustom-delivery-value]').textContent = estimate || '';
    }
  }
  // The theme emits a non-bubbling native change on its authoritative variant selector.
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element) || !event.target.matches('select[name="id"]')) return;
    const product = event.target.closest('.acustom-fabric-pdp');
    if (product) sync(product);
  }, true);
  function setup(scope) { scope.querySelectorAll('.acustom-fabric-pdp').forEach(sync); }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
